import { Component, effect, inject, OnInit, Signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { LogService } from '../../services/log.service';
import { Router } from '@angular/router';
import { StepperComponent } from '../../components/stepper/stepper.component';
import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from '../../components/button/button.component';
import { HeaderComponent } from '../../components/header/header.component';
import { TextAreaComponent } from '../../components/text-area/text-area.component';
import { ConfirmDialogComponent } from '../../components/confirm-dialog/confirm-dialog.component';
import TYPES from '../../constants/types';
import { UntypedFormControl } from '@angular/forms';
import { Log } from '../../models/log';
import { DATABASE_SERVICE, DatabaseService } from '../../services/database.service';

@Component({
  selector: 'app-did-do',
  imports: [
    HeaderComponent,
    StepperComponent,
    ButtonComponent,
    TranslatePipe,
    MatSnackBarModule,
    DialogModule,
    TextAreaComponent
  ],
  templateUrl: './did-do.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './did-do.component.scss'
})
export class DidDoComponent {

  BUTTON_TYPES:any;
  step: Signal<StepperComponent | undefined> = viewChild<StepperComponent>('stepper');

  whatDidDoControl: UntypedFormControl;

  snackBar:MatSnackBar = inject(MatSnackBar);
  dialog: Dialog = inject(Dialog);
  translate: TranslateService = inject(TranslateService);

  databaseService:DatabaseService<Log> = inject(DATABASE_SERVICE);

  constructor(
    private router:Router,
    private logService: LogService<Log>,
  ){
    effect( ()=> {
      this.step()?.steps()[5].nativeElement.classList.add('active');
    });

    this.whatDidDoControl = new UntypedFormControl(this.logService.log().did_do || '');

    this.BUTTON_TYPES = TYPES.UI.BUTTON;
  }

  async next(){
    this.logService.log.update( 
      (current) => {
        return {
          ...current,
          did_do: this.whatDidDoControl.value,
        }
      }
    );    
    // this.router.navigate(['/other-thought'], { replaceUrl: true });
    this.router.navigate(['/other-thought']);
  }

  back(){
    // this.router.navigate(['/did-think'], { replaceUrl: true });
    history.back();
  }

  close(){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'log-close-dialog.alert_title',
        message: 'log-close-dialog.alert_message'
      },
    });

    dialogRef.closed.subscribe((result:any)  => {
      if(result?.action === 'continue'){
        this.logService.canAccessMindLogRegister.set(false);
        this.router.navigate(['/home'], { replaceUrl: true });  
      }
    });   
  }

}